// src/services/api.ts
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

const api = axios.create({
  baseURL: 'http://127.0.0.1:9090/api/',
});

export default api;

export const API_ENDPOINTS = {
  CONTRATOS: 'http://localhost:9090/api/logistica/contratos/',
  FARDOS: 'http://localhost:9090/api/logistica/fardos/',
  // ... otros endpoints
};

const cache = new Map();

export const useApi = () => {
  const { getAccessTokenSilently } = useAuth0();

  const request = useCallback(async (endpoint: string, options: any = {}) => {
    const cacheKey = `${endpoint}-${JSON.stringify(options)}`;
    
    // Verificar cache
    if (cache.has(cacheKey)) {
      return cache.get(cacheKey);
    }

    const token = await getAccessTokenSilently();
    const response = await axios({
      ...options,
      url: endpoint,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    // Guardar en cache
    cache.set(cacheKey, response);
    
    // Limpiar cache después de 5 minutos
    setTimeout(() => cache.delete(cacheKey), 5 * 60 * 1000);

    return response;
  }, [getAccessTokenSilently]);

  return { request };
};
